export default {
  ACTIVE: "Lopend",
  SUPPRESS_PROLONGATION: "Prolongatie onderdrukken",
  BEING_EDITED: "In bewerking",
  SUSPENDED: "Opgeschort",
  REQUESTED: "In aanvraag",
  PREMIUM_FREE: "Premievrij",
  QUOTATION: "Offerte",
  ACTIVE_ELSEWHERE: "Loopt elders",
  SINGLE_PREMIUM_POLICY: "Koopsompolis",
  REDEMPTION: "Afkoop",
  NO_INSURRANCE: "Geen eigen verzekering",
  VALUE_TRANSFERRED: "Waarde overgedragen",
  EXHALED: "Geëxpireerd",
  SHORTERM_INSURANCE: "Kortlopende verzekering",
  PREMIUM_VACANCY: "Premievakantie",
  TAKING_INVENTORY: "Inventarisatie",
  IN_PROLONGATION: "In prolongatie",
  REJECTED: "Afgewezen",
  ENDING: "Aflopend",
  EXPIRING: "Gaat vervallen",
  EXPIRED: "Vervallen",
};
